define((require) => {
    "use strict";

    const FileDropManager       = require("services/FileDropManager");
    const CustomFontFileStorage = require("services/files/CustomFontFileStorage");
    const CustomFontModel       = require("editor/services/fonts/customFonts/CustomFontModel");

    const CustomFontDropManager = FileDropManager.extend("CustomFontDropManager", {

        fileModel: CustomFontModel,

        fileStorage: CustomFontFileStorage

    });

    // Singleton
    return new CustomFontDropManager();
});



// WEBPACK FOOTER //
// ./src/editor/services/CustomFontDropManager.js